document.addEventListener('DOMContentLoaded', function() {
  const initProductForms = () => {
    const productInfos = document.querySelectorAll('.product-info');

    productInfos.forEach(container => {
      // Prevent multiple initializations
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      const variantRadios = container.querySelectorAll('.variant-radio');
      const variantIdInput = container.querySelector('.js-product-variant-id');
      const inventoryMessage = container.querySelector('.js-inventory-message');
      const priceElement = container.querySelector('.js-product-price');
      const quantityInput = container.querySelector('.quantity-input');
      const quantityBtns = container.querySelectorAll('.quantity-btn');
      const addToCartBtn = container.querySelector('.js-add-to-cart-btn');
      const checkoutBtnWrapper = container.querySelector('.js-checkout-button-wrapper');
      const productForm = container.querySelector('.product-form-element');

      const variantsDataEl = container.querySelector('.js-product-variants-data');
      const variantsData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];

      function updateVariant() {
        if(!variantsData || variantsData.length === 0) return;
        
        let matchedVariant;
        
        if (variantRadios.length === 0) {
          // If there are no radio buttons, it's a product with only a default variant
          matchedVariant = variantsData[0];
        } else {
          const selectedOptions = Array.from(container.querySelectorAll('.variant-radio:checked')).map(r => r.value);
          
          matchedVariant = variantsData.find(variant => {
            if(variant.options) {
               return variant.options.every((option, index) => option === selectedOptions[index]);
            }
            return false;
          });
        }

        if (matchedVariant) {
          if (variantIdInput) variantIdInput.value = matchedVariant.id;
          
          // Update price using Shopify's pre-formatted string
          if (priceElement) {
            let isSoldOut = !matchedVariant.available;
            let isOnSale = matchedVariant.compare_at_price > matchedVariant.price && !isSoldOut;

            if (isOnSale) {
               let discountAmount = matchedVariant.compare_at_price - matchedVariant.price;
               let discountPercentage = Math.round((discountAmount * 100) / matchedVariant.compare_at_price);

               priceElement.innerHTML = `
                  <s class="product-price-compare">${matchedVariant.compare_at_price_formatted}</s>
                  <span class="product-price-sale">${matchedVariant.price_formatted}</span>
                  <span class="product-badge-sale">-${discountPercentage}%</span>
               `;
               
               if (checkoutBtnWrapper) {
                  checkoutBtnWrapper.classList.add('is-on-sale');
               }
            } else {
               priceElement.innerHTML = `<span class="product-price-regular">${matchedVariant.price_formatted}</span>`;
               
               if (checkoutBtnWrapper) {
                  checkoutBtnWrapper.classList.remove('is-on-sale');
               }
            }
          }

          // Update pills UI
          container.querySelectorAll('.variant-pill').forEach(pill => {
            pill.classList.remove('is-active');
          });
          
          variantRadios.forEach(radio => {
            if (radio.checked) {
              const pill = radio.closest('.variant-pill');
              if (pill) pill.classList.add('is-active');
            }
          });

        // Update Inventory message and Buttons
          if (matchedVariant.available) {
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
            }
            if (checkoutBtnWrapper) {
              checkoutBtnWrapper.classList.remove('is-disabled');
            }
            
            if (quantityInput) {
              quantityInput.disabled = false;
              const quantityWrapper = container.querySelector('.quantity-input-wrapper');
              if (quantityWrapper) quantityWrapper.classList.remove('is-disabled');
            }
            if (quantityBtns) {
              quantityBtns.forEach(btn => btn.disabled = false);
            }

            if (inventoryMessage) {
              if (matchedVariant.inventory_management !== null && matchedVariant.inventory_quantity <= 5 && matchedVariant.inventory_quantity > 0) {
                inventoryMessage.textContent = 'Low on stock';
              } else {
                inventoryMessage.textContent = '';
              }
            }
          } else {
            if (addToCartBtn) {
              addToCartBtn.disabled = true;
            }
            if (checkoutBtnWrapper) {
              checkoutBtnWrapper.classList.add('is-disabled');
            }
            
            if (quantityInput) {
              quantityInput.disabled = true;
              const quantityWrapper = container.querySelector('.quantity-input-wrapper');
              if (quantityWrapper) quantityWrapper.classList.add('is-disabled');
            }
            if (quantityBtns) {
              quantityBtns.forEach(btn => btn.disabled = true);
            }
            
            if (inventoryMessage) {
              inventoryMessage.textContent = 'Sold out';
            }
          }
          
          // Update main image if variant has one - only within this container context if needed
          if (matchedVariant.featured_image_url) {
             const localMainImage = container.querySelector('.js-main-product-image') || document.getElementById('main-product-image');
             if(localMainImage) {
                 localMainImage.src = matchedVariant.featured_image_url;
                 localMainImage.removeAttribute('srcset');
             }
          }

          // Update Preorder 'Ships on' Property and UI
          const preorderPropertyInput = container.querySelector('.js-preorder-property');
          const preorderBadge = container.querySelector('.js-product-badge-preorder');
          const preorderDelivery = container.querySelector('.js-product-preorder-delivery');
          const preorderDateDisplay = container.querySelector('.js-preorder-date-display');
          const checkoutBtnWrapperForPreorder = container.querySelector('.js-checkout-button-wrapper');

          if (
            matchedVariant.inventory_policy === 'continue' &&
            matchedVariant.inventory_quantity <= 0 &&
            matchedVariant.preorder_days_to_ship
          ) {
            const daysToShip = parseInt(matchedVariant.preorder_days_to_ship, 10);
            const shipDate = new Date();
            shipDate.setDate(shipDate.getDate() + daysToShip);
            
            const optionsWithYear = { year: 'numeric', month: 'short', day: 'numeric' };
            const formattedDateWithYear = shipDate.toLocaleDateString('en-US', optionsWithYear);
            
            const optionsWithoutYear = { month: 'short', day: 'numeric' };
            const formattedDateWithoutYear = shipDate.toLocaleDateString('en-US', optionsWithoutYear);

            if (preorderPropertyInput) {
              preorderPropertyInput.value = formattedDateWithYear;
              preorderPropertyInput.disabled = false;
            }
            if (preorderBadge) {
              preorderBadge.style.display = 'block';
            }
            if (preorderDelivery && preorderDateDisplay) {
              preorderDateDisplay.textContent = formattedDateWithoutYear;
              preorderDelivery.style.display = 'flex';
            }
            if (checkoutBtnWrapperForPreorder) {
              checkoutBtnWrapperForPreorder.classList.add('is-preorder');
            }
            if (addToCartBtn) {
              addToCartBtn.style.display = 'none';
            }
          } else {
            if (preorderPropertyInput) {
              preorderPropertyInput.value = '';
              preorderPropertyInput.disabled = true;
            }
            if (preorderBadge) {
              preorderBadge.style.display = 'none';
            }
            if (preorderDelivery) {
              preorderDelivery.style.display = 'none';
            }
            if (checkoutBtnWrapperForPreorder) {
              checkoutBtnWrapperForPreorder.classList.remove('is-preorder');
            }
            if (addToCartBtn) {
              addToCartBtn.style.display = '';
            }
          }
        }
      }

      variantRadios.forEach(radio => {
        radio.addEventListener('change', updateVariant);
      });

      quantityBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          if (!quantityInput) return;
          let currentVal = parseInt(quantityInput.value, 10);
          if (isNaN(currentVal)) currentVal = 1;
          
          if (this.dataset.action === 'plus') {
            quantityInput.value = (currentVal + 1).toString().padStart(2, '0');
          } else if (this.dataset.action === 'minus' && currentVal > 1) {
            quantityInput.value = (currentVal - 1).toString().padStart(2, '0');
          }
        });
      });
      
      // Format initial quantity if it's not already padded
      if(quantityInput) {
         let currentVal = parseInt(quantityInput.value, 10);
         if (!isNaN(currentVal)) {
            quantityInput.value = currentVal.toString().padStart(2, '0');
         }
      }

      // Initialize variant state on load
      updateVariant();

      // Handle Add to Cart AJAX
      if (productForm) {
        productForm.addEventListener('submit', function(e) {
          let isBuyNow = false;
          if (document.activeElement && document.activeElement.classList.contains('shopify-payment-button__button')) {
             isBuyNow = true;
          }

          if (isBuyNow) {
            return; // Let native submit happen
          }
          
          e.preventDefault();
          
          const formData = new FormData(productForm);
          
          const originalBtnText = addToCartBtn ? addToCartBtn.textContent : '';
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Adding...';
          }

          const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
            return response.json();
          })
          .then(() => {
            if (typeof window.showToast === 'function') {
              window.showToast('Item added to cart!');
            }

            // Update header cart count and the cart itself if we're on the cart page
            fetch(rootUrl + '?sections=header,cart')
              .then(res => res.json())
              .then(sections => {
                // Update Header Cart Count
                const headerHtml = sections['header'];
                if (headerHtml) {
                  const parsedHeader = new DOMParser().parseFromString(headerHtml, 'text/html');
                  const newCartBubble = parsedHeader.querySelector('#cart-icon-bubble');
                  const currentCartBubble = document.getElementById('cart-icon-bubble');
                  
                  if (newCartBubble && currentCartBubble) {
                    currentCartBubble.innerHTML = newCartBubble.innerHTML;
                  }
                }

                // Update Cart Items if we are on the cart page
                const cartHtml = sections['cart'];
                if (cartHtml) {
                   const parsedCart = new DOMParser().parseFromString(cartHtml, 'text/html');
                   const newCartContainer = parsedCart.querySelector('.cart-container');
                   const currentCartContainer = document.querySelector('.cart-container');
                   if (newCartContainer && currentCartContainer) {
                      currentCartContainer.innerHTML = newCartContainer.innerHTML;
                   }
                }
              });
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            alert('Error adding item to cart.');
          })
          .finally(() => {
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = originalBtnText;
            }
          });
        });
      }
    });

    const productGalleryDesktop = document.querySelectorAll('.product-gallery-desktop');
    // Handle Thumbnail Clicks - scoped for forms
    productGalleryDesktop.forEach(container => {
      const thumbnails = container.querySelectorAll('.desktop-thumbnail, .js-desktop-thumbnail');
      thumbnails.forEach(thumbnail => {
        // Prevent multiple listeners
        if (thumbnail.dataset.listenerAdded) return;
        thumbnail.dataset.listenerAdded = 'true';

        thumbnail.addEventListener('click', function(e) {
          if (e.target.closest('.video-thumbnail-btn')) {
            return;
          }
          const largeImageUrl = this.getAttribute('data-large-image');
          if (largeImageUrl) {
             const mainImage = container.querySelector('.js-main-product-image') || document.getElementById('main-product-image');
             if (mainImage) {
               mainImage.src = largeImageUrl;
               mainImage.removeAttribute('srcset'); // Force browser to use the new src
             }
          }
        });
      });
    });
  };

  initProductForms();

  // Expose initialization function globally so it can be called when modals open
  window.initProductForms = initProductForms;
});
